<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="delivery-note"
    :data-model="dataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :almondcoDespatchData="almondcoDespatchData"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import { ProductService } from "../../_services/api/products/product.service";
import { AlmondcoDespatchDataService } from "../../_services/api/sales/almondco-despatch-data.service";
import { InvoiceCreditService } from "../../_services/api/sales/invoice-credit.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      dataModel: undefined,
      reload: false,
      validationSummary: [],
      almondcoDespatchData: undefined,
      almondcoQCData: undefined,
    };
  },

  async created() {},
  async mounted() {
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    backButtonRoute() {
      return "/despatched";
    },

    getScreenJson() {
      var screenJson = {
        title: "Delivery Note",
        endpoint: {
          primary: "DeliveryNote",
          filter: `Code eq ${this.baseView.id}`,
          postProcess: this.deliveryNotePostProcess,
        },
        headerData: {
          headerToolbar: {
            screenName: "Delivery Note Review",
            pdf: this.baseView.mode == "review",
            email: this.baseView.mode == "review",
            audit: this.baseView.mode == "review",
            status: true,
            notes: false,
            save: false,

            emailMenuItems: {
              referenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "InvoiceNo",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
              makeDisabled: (dataModel, emailRecords) => {
                var items = [];

                emailRecords.forEach((element) => {
                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });

                return items;
              },
            },

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "Date",
                    },
                    {
                      screenField: "Invoice",
                      label: {
                        text: "Invoice #",
                      },
                      dataField: "InvoiceNo",
                    },
                    {
                      screenField: "InvoiceDate",
                      label: {
                        text: "Invoice Date",
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      // screenField: "DeliverTo",
                      dataField: "DeliverTo",
                      label: {
                        text: "Deliver To",
                      },
                    },
                    {
                      screenField: "ConNote",
                    },
                    {
                      screenField: "CurrencyCode",
                      dataField: "Currency",
                    },
                    {
                      screenField: "ExchangeRate",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "Branch",
                      label: {
                        text: "Branch",
                      },
                    },
                    {
                      dataField: "Division",
                      label: {
                        text: "Division",
                      },
                    },
                    {
                      dataField: "SOType",
                      label: { text: "SO Type" },
                    },
                    {
                      screenField: "SalesRep",
                      dataField: "SalesRep",
                      // label: {
                      //   text: "Rounding",
                      // },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: "DeliveryNote",
                text: "Delivery # ",
              },
              secondary: {
                dataField: "SalesOrderNo",
                text: " for Sales Order # ",
              },
            },
            secondary: {
              dataField: "CustomerName",
              text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "DeliveryNoteDetail",
              filter: ["DeliveryNote eq " + this.baseView.id],
              sort: ["LineNo", { selector: "LineNo", asc: true }],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.postProcessDeliveryNoteDetail,
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: false,
          },
          columns: [
            {
              screenField: "Item",
              label: "Product/Account",
              dataField: "ProductCode",
              gridDataField: "ProductCode",
              // sortOrder: "asc",
              // sortIndex: 0,
              cellTemplateRecord: {
                image: {
                  codeDataField: "ProductCode",
                  descriptionDataField: "ProductDescription",
                  hasPrimaryImageDataField: "HasPrimaryImage",
                },
                primary: [
                  {
                    dataField: "ProductDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "ProductCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ProductCode",
                  label: "Product Code",
                },
                {
                  dataField: "ProductDescription",
                  label: "Product Name",
                },
              ],
              // fixed: true,
              // fixedPosition: "left",
              allowHiding: false,
            },
            {
              screenField: "SalesUM",
              dataField: "UM",
              width: 80,
              minWidth: 80,
            },
            {
              screenField: "Quantity",
              dataField: "Ordered",
              label: "Ordered",
              minWidth: 120,
            },
            {
              screenField: "Quantity",
              dataField: "Delivered",
              label: "Delivered",
              minWidth: 120,
            },
            {
              screenField: "Quantity",
              dataField: "Outstanding",
              label: "Outstanding",
              minWidth: 120,
            },
            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              cssClass: "padding-7",
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Despatch Data",
                      data: data,
                      visible: FeatureStorage.checkPermission(
                        "AlmondcoDespatchData",
                        "create"
                      ),
                      clickAction: this.enableAlmondcoDespatchData,
                      disabled: !data.data.almondcoQCData,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                // if (data.data.InvoiceTy
                if (data)
                  return !FeatureStorage.checkPermission(
                    "AlmondcoDespatchData",
                    "create"
                  );
              },
            },
            {
              screenField: "Quantity",
              dataField: "LineNo",
              label: "LineNo",
              minWidth: 50,
              visible: false,
              showInColumnChooser: false,
            },
          ],
          childColumns: [
            {
              screenField: "Batch",
              gridDataField: "BatchNo",
              allowEditing: false,
              width: ColumnWidth.BatchNo.width,
              minWidth: ColumnWidth.BatchNo.minWidth,
            },

            {
              screenField: "Supplier",
              allowEditing: false,
              gridDataField: "SupplierCode",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
            },
            {
              screenField: "UseByDate",
              allowEditing: false,
            },
            {
              screenField: "ManufacturedDate",
              allowEditing: false,
            },
            {
              screenField: "SalesUMQty",
              gridDataField: "SalesUMBatchQty",
              label: "Sales UM Qty",
              allowEditing: false,
            },
            {
              screenField: "SalesUMQty",
              gridDataField: "StockUMBatchQty",
              label: "Stock UM Qty",
              allowEditing: false,
            },
          ],
        },
        footerData: false,
      };
      return screenJson;
    },
  },
  methods: {
    async enableAlmondcoDespatchData(data) {
      this.setLoading = true;
      this.$store.dispatch("dataContext/setAllowDataContext", false);

      await ProductService.getByCode(data.ProductCode).then((res) => {
        data.Product = res.data.value[0];
        data.CartonSize = res.data.value[0].PackSize;
        data.StockUM = res.data.value[0].UnitOfMeasureCode;
      });

      data.ItemCode = data.ProductCode;

      this.almondcoDespatchData = {
        visible: true,
        popUpCallBack: this.popUpCallBack,
        data: data,
        model: this.$refs["delivery-note"].getTransactionData(),
        type: "delivery-note",
      };
    },
    popUpCallBack(updated) {
      this.setLoading = false;
      this.$store.dispatch("dataContext/setAllowDataContext", true);
      this.almondcoDespatchData = undefined;
      if (updated)
        this.$refs["delivery-note"].$refs["transactionGrid"].gridRepaint();
    },
    async initialized() {
      if (FeatureStorage.checkPermission("AlmondcoDespatchData", "create")) {
        await AlmondcoDespatchDataService.checkQCData(this.baseView.id)
          .then((res) => {
            if (res.data.value.length > 0) this.almondcoQCData = res.data.value;
          })
          .catch((err) => {
            if (err) this.$logger.debug("error", err);
          });
      }

      this.loaded = true;
    },
    deliveryNotePostProcess(data) {
      data.Status = data.FriendlyStatus;
      data.DeliveryNote = data.Code;
      data.Invoice = data.InvoiceNo;
      return data;
    },
    postProcessDeliveryNoteDetail(data) {
      let items = [];
      data.forEach((element) => {
        element.almondcoQCData = false;

        if (this.almondcoQCData) {
          this.almondcoQCData.forEach((item) => {
            if (
              element.DeliveryNote == item.DeliveryNote &&
              element.LineNo == item.DeliveryNoteLineNo
            )
              element.almondcoQCData = true;
          });
        }

        // handle batch data
        if (element.IsBatchProduct !== "No" && element.InvoiceLineNo > 0) {
          InvoiceCreditService.getProductBatches(
            `InvoiceCode eq ${element.InvoiceNo} and InvoiceLineNo eq ${element.InvoiceLineNo}`,
            {
              select: [
                "BatchNo",
                "ItemCode",
                "StockUMQty",
                "SalesUMQty",
                "SupplierCode",
                "SupplierName",
                "InvoiceLineNo",
                "SalesUMCreditedQty",
                "UseByDate",
                "InvoiceCode",
                "ManufacturedDate",
              ],
            }
          ).then((response) => {
            element.InvoiceProductBatches = response.data.value.map((el) => {
              let batchLine = {
                BatchNo: el.BatchNo,
                ItemCode: el.ItemCode,
                StockUMBatchQty: el.StockUMQty,
                SalesUMBatchQty: el.SalesUMQty,
                SalesUMInvoiceConversion: element.SalesUMInvoiceConversion,
                SupplierCode: el.SupplierCode,
                SupplierName: el.SupplierName,
                InvoiceLineNo: el.InvoiceLineNo,
                SalesUMCreditedQty: el.SalesUMCreditedQty,
                UseByDate: el.UseByDate,
                ManufacturedDate: el.ManufacturedDate,
              };
              return batchLine;
            });
          });

          items.push(element);
        } else items.push(element);
      });
      return items;
    },
  },
};
</script>
